import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SubTemplatesUI from './subtemplatesui';


export default class SubTemplates extends Plugin {
  static get pluginName() {
    return 'SubTemplates';
  }

  static get requires() {
    return [ SubTemplatesUI];
  }
}
